import { render } from "./SendSamplingList.vue?vue&type=template&id=3d4f0c09"
import script from "./SendSamplingList.vue?vue&type=script&lang=js"
export * from "./SendSamplingList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__